import { render, staticRenderFns } from "./detailSomeColumns.vue?vue&type=template&id=2937eba2"
import script from "./detailSomeColumns.vue?vue&type=script&lang=js"
export * from "./detailSomeColumns.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports